import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IotJobStatus } from "../../commonApi";
import CustomDataTable from "./CustomDataTable"; // Custom table component
import arrowBackImg from "../../../src/assets/images/arrow_back.svg";

const IotJobStatusGrid = () => {
  const { jobId } = useParams();
  const navigate = useNavigate(); // Hook for navigation
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [nextToken, setNextToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tokenHistory, setTokenHistory] = useState([]); // Stores tokens for previous pages

  useEffect(() => {
    if (jobId) {
      loadData(1, null, true);
    }
  }, [jobId, perPage]);

  const loadData = async (page, token, isFirstPage = false) => {
    setLoading(true);
    try {
      const params = {
        pageSize: perPage,
        pageNo: token ? undefined : page,
        nextToken: token || undefined,
      };

      const response = await IotJobStatus(jobId, params);

      setData(response.data?.things.slice(0, perPage) || []);

      if (isFirstPage) {
        setTokenHistory([]); // Reset history on first page load
      }

      // Store `nextToken` history for previous navigation
      if (token && !isFirstPage) {
        setTokenHistory((prev) => [...prev, token]);
      }

      setTotalRows(response.data?.totalDevicesCount ?? 0);
      setNextToken(response.data.nextToken || null);
    } catch (error) {
      toast.error("Error fetching data!");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page > currentPage) {
      // Moving forward (Next Page)
      if (nextToken) {
        loadData(page, nextToken);
      }
    } else if (page < currentPage && tokenHistory.length > 1) {
      // Moving backward (Previous Page)
      const previousToken = tokenHistory[tokenHistory.length - 2] || null;
      setTokenHistory((prev) => prev.slice(0, -1)); // Remove last token
      loadData(page, previousToken);
    }

    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setNextToken(null);
    setCurrentPage(1);
    loadData(1, null, true); // Reset pagination
  };

  const handleBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  const columns = [
    { name: "Thing Name", selector: (row) => row.thingName, sortable: true },
    { name: "Job Status", selector: (row) => row.jobStatus, sortable: true },
  ];

  return (
    <div className="custom_tab_wrapper">
      <div className="action_cta">
        <ul className="nav nav-tabs" id="myTab" role="tablist" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <li className="nav-item" role="presentation">
            <button className="nav-link active" id="firmware-tab" data-bs-toggle="tab" data-bs-target="#firmware" type="button" role="tab" aria-controls="firmware" aria-selected="true">
              Iot Jobs Status : {totalRows}
            </button>
          </li>
          <button className="btn page_back_btn" data-bs-target="#delete-model"
            style={{marginRight:"17px"}}
            onClick={handleBack}>
            <img src={arrowBackImg} alt="Arrow-back" height="16" width="16" />
            Back
          </button>
        </ul>
      </div>
      <div className="tab-pane fade show active" id="home" role="tabpanel">
        <div className="tab_content_wrapper full_height_tab">
          <div className="table-responsive h-100vh-150px">
            <div className="custom_table">
              <CustomDataTable
                columns={columns}
                data={data}
                totalRows={totalRows}
                loading={loading}
                handlePageChange={handlePageChange}
                handleRowsPerPageChange={handleRowsPerPageChange}
                currentPage={currentPage}
                perPage={perPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IotJobStatusGrid;
